import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";

import Close from "../../../Assets/close.svg";
import styles from "./DeleteBuildModal.module.scss";
import { useUnpublishBuild } from "../../../hooks/DevAppHooks";

const UnpublishBuildModal = ({ showUnpublishBuild, setShowUnpublishBuild, build }) => {
  const handleClose = () => setShowUnpublishBuild(false);
//   const { mutate } = useUnpublishBuild(build.id);
  const handleSubmit = () => {
    // mutate();
  };

  return (
    <>
      <Container>
        <Modal
          show={showUnpublishBuild}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Delete Build
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowUnpublishBuild(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <h4>Are you sure you want to unpublish this build?</h4>
              <div><h3>If yes then this build will be unpublished from the app store.</h3></div>
              <div className={styles.buttonContainer}>
                <SecondaryButton onClick={() => setShowUnpublishBuild(false)}>
                  No
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                    setShowUnpublishBuild(false);
                  }}
                >
                  Yes
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default UnpublishBuildModal;
